import { } from './queries';
//import { AppContext } from './AppContext';
import { CREATE_NEW_BOOKING, UPDATE_BOOKING_FIELD } from './mutation';
import { GET_BOOKINGS_BY_USERID, CALCULATE_FARE, GET_YESTERDAY_ONWARD_BOOKINGS, SEND_BOOKINGMSG_USER, SEND_BOOKINGMSG_DRIVER, NEXT_24_HRS_BOOKINGS, GET_BOOKINGS_BY_PHONE, GET_BOOKING_BY_BOOKINGID } from './queries';
import client from "./apolloClient";
import { Booking, BookingInput, Payment } from "../models/booking";
import { AppContext } from './AppContext'
import Cookies from 'js-cookie';

const loggedAuthToken = Cookies.get('loggedAuthToken');

export const createBooking = async (newBooking: BookingInput): Promise<Booking | null> => {
  try {
    const { data } = await client.mutate({
      mutation: CREATE_NEW_BOOKING,
      variables: { newBooking },
    });
    return data?.createBooking;
  } catch (error) {
    console.log("Error fetching create booking:" + error)
    return null;
  }
}

export const getBookingsByUserId = async (userId: string | undefined, ): Promise<Booking[] | null> => {
  if (AppContext.bookings && AppContext.bookings.length > 0) {
    return AppContext.bookings;
  }
  if (userId === undefined) {
    return null;
  }
  try {
    const { data } = await client.query({
      query: GET_BOOKINGS_BY_USERID,
      variables: { userId },
    });
    return data?.getBookingsByUserId;
  } catch (error) {
    console.log('Error fetching getBookingsByUserId:', error);
    return null;
  }
}

export const getBookingsByPhone = async (phone: string, ): Promise<Booking[] | null> => {

  try {
    const { data } = await client.query({
      query: GET_BOOKINGS_BY_PHONE,
      variables: { phone },
    });
    return data?.getBookingsByPhone;
  } catch (error) {
    console.log('Error fetching getBookingsByPhone:', error);
    return null;
  }
}

export const getBookingByBookingId = async (bookingId: string | undefined, ): Promise<Booking | null> => {
 
  if (!bookingId)
    return null

  try {
    const { data } = await client.query({
      query: GET_BOOKING_BY_BOOKINGID,
      variables: { bookingId },
    });
    return data?.getBookingByBookingId;
  } catch (error) {
    console.log('Error fetching getBookingByBookingId:', error);
    return null;
  }
}
// export const getYesterDayOnwardBookings = async (): Promise<Booking[] | null> => {

//   try {
//     const { data } = await client.query({
//       query: GET_YESTERDAY_ONWARD_BOOKINGS,
//       variables: {},
//     });
//     return data?.getYesterdayOnwardsBookings;
//   } catch (error) {
//     console.log('Error fetching getYesterdayOnwardsBookings:', error);
//     return null;
//   }
// }

export const getOngoingBookingsByUserId = async (userId: string | undefined, ): Promise<Booking[] | undefined> => {

  const bookings = await getBookingsByUserId(userId);
  const filtered = bookings?.filter(item => item.status === 'STARTED').sort((a, b) => { return a.bookingDate.localeCompare(b.bookingDate) });
  return filtered;
}

// export const getYerterdayOnwardsOngoingBookings = async (): Promise<Booking[] | undefined> => {

//   const bookings = await getYesterDayOnwardBookings();
//   const filtered = bookings?.filter(item => item.status === 'STARTED').sort((a, b) => { return a.bookingDate.localeCompare(b.bookingDate) });

//   return filtered;
// };


export const getNextBookingsByUserId = async (userId: string | undefined, ): Promise<Booking[] | undefined> => {
  const bookings = await getBookingsByUserId(userId);
  const filtered = bookings?.filter(item => (item.status === 'CONFIRMED' || item.status === 'STARTED' || item.status === 'NEW')).sort((a, b) => { return a.bookingDate.localeCompare(b.bookingDate) });
  return filtered;
}

export const getFinishedBookingsByUserId = async (userId: string | undefined, ): Promise<Booking[] | undefined> => {
  const bookings = await getBookingsByUserId(userId);
  const filtered = bookings?.filter(item => item.status === 'FINISHED' || item.status === 'CANCELLED').sort((a, b) => { return b.bookingDate.localeCompare(a.bookingDate) });
  return filtered;
}

export const getNext24HourBookings = async (selectedDate: string): Promise<Booking[] | null> => {

  try {
    const { data } = await client.query({
      query: NEXT_24_HRS_BOOKINGS,
      variables: { selectedDate },
    });
    return data?.getNext24HourBookings;
  } catch (error) {
    console.log('Error fetching getNext24HourBookings:', error);
    return null;
  }
};


export const calculatePayment = async (booking: Booking): Promise<Payment | null> => {
  try {
    const { data } = await client.query({
      query: CALCULATE_FARE,
      variables: { booking },
    });
    return data?.calculateFare;
  } catch (error) {
    console.log('Error fetching calculate Payment :', error);

    return null;
  }
}

export const updateBookingField = async (bookingId: string, fieldName: string, fieldValue: string): Promise<Booking | null> => {
  try {
    const { data } = await client.query({
      query: UPDATE_BOOKING_FIELD,
      variables: {
        "bookingId": bookingId,
        "fieldName": fieldName,
        "fieldValue": fieldValue,
      },
      context: {
        headers: {
          Authorization: loggedAuthToken ? `Bearer ${loggedAuthToken}` : '',
        },
      }
    });
    //  await refreshAppContext(data?.updateBooking);
    return data?.updateBooking;
  } catch (error) {
    console.log('Error fetching  updateBookingField:', error);
    return null;
  }
}




function removeTypename(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(item => removeTypename(item));
  }

  if (obj && typeof obj === 'object') {
    const { __typename, _id, ...rest } = obj; // Remove both __typename and _id

    return Object.keys(rest).reduce((acc: { [key: string]: any }, key: string) => {
      acc[key] = removeTypename(rest[key]);
      return acc;
    }, {});
  }
  return obj;
}




export const sendBookingMsgToUser = async (booking: Booking, ): Promise<Boolean | null> => {

  const newbooking = removeTypename(booking)
  try {
    const { data } = await client.query({
      query: SEND_BOOKINGMSG_USER,
      variables: { booking: newbooking },
    });

    return data?.sendBookingMsgToUser;
  } catch (error) {
    console.log('Error fetching sendBookingMsgTo user:', error);
    return null;
  }
}

export const sendBookingMsgToDriver = async (booking: Booking, driverId: string, ): Promise<Boolean | null> => {
  const newbooking = removeTypename(booking)
  // console.log(JSON.stringify(newbooking), +"   " + driverId)
  try {
    const { data } = await client.query({
      query: SEND_BOOKINGMSG_DRIVER,
      variables: { booking: newbooking, driverId },
    });

    return data?.sendBookingMsgToDriver;
  } catch (error) {
    console.log('Error fetching sendBookingMsg to driver:', error);
    return null;
  }
}

export const getLastMinuteFareInfo = async (bookingDateTime: string, selectedFromCity: string, bookings: Booking[] | null): Promise<boolean> => {
  console.log(bookingDateTime)
  const selectedBookingDateTime = new Date(bookingDateTime)

  if (!bookings || bookings.length === 0)
    return false;

  const filteredBookings = bookings?.filter(booking => booking.returnRide === false && booking.fromCity.toLowerCase() === 'pune');

  for (const booking of filteredBookings) {
    const bookingDateUTC = new Date(booking.bookingDate);
    const diffInMs = selectedBookingDateTime.getTime() - bookingDateUTC.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);

    if (diffInHours > 0 && diffInHours <= 6) {
      if (selectedFromCity === 'mumbai') {
        console.log("Selected:", selectedBookingDateTime.toString())
        console.log("bookingId :", booking.bookingId)
        console.log("previous bookingdate:", bookingDateUTC.toString())
        console.log("diffInHours: ", diffInHours)
        console.log("is eligible = true");
        return true;
      }
    }
  }
  console.log("is eligible = false");
  return false;
};
